import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'courseCard.relatedSkillsHeading': {
    id: 'courseCard.relatedSkillsHeading',
    defaultMessage: 'Related skills',
    description: 'Heading of related skills section',
  },
  'courseCard.aLaCarteBadge': {
    id: 'courseCard.aLaCarteBadge',
    defaultMessage: 'A la carte',
    description: 'Badge text for the `A La Carte` catalog badge.',
  },
  'courseCard.subscriptionBadge': {
    id: 'courseCard.subscriptionBadge',
    defaultMessage: 'Subscription',
    description: 'Badge text for the `Subscription` catalog badge.',
  },
  'courseCard.priceNotAvailable': {
    id: 'courseCard.priceNotAvailable',
    defaultMessage: ' Not Available',
    description:
      'When a course price is not available, notify learners that there is no data available to display.',
  },
  'courseCard.availableNow': {
    id: 'courseCard.availableNow',
    defaultMessage: 'Available now',
    description: 'Availability label shown on a course card when the advertised session has already started.',
  },
  'courseCard.startingSoon': {
    id: 'courseCard.startingSoon',
    defaultMessage: 'Starting soon',
    description: 'Availability label shown on a course card when the advertised session has not started yet.',
  },
});

export default messages;
